module.exports = __webpack_public_path__ + "static/MilkSplash-f2bb6810c816da919b781fac587fb247.jpg";